import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';
import {Helmet} from 'react-helmet';
import './preventionMeasuresPage.scss';

/**
 * The PreventionMeasuresPage component.
 *
 * @constructor
 */
export class PreventionMeasuresPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="prevention-measures-page" className="system-page">
        <Helmet>
          <title>Damage Prevention Measures - NEI</title>
          <meta name = "description" content ="The following list highlights proactive, voluntary steps taken by pipeline operators to ensure reliability and integrity of their systems." />
        </Helmet>
        <div className="container">
          <div className="row">
            <div className="col">
              <p>The time and investment necessary to protect the operational performance and integrity of underground infrastructure is similar to a homeowner wanting to protect and maintain the value associated with their home.</p>
              <p className="last">The following list highlights proactive, voluntary steps taken by pipeline operators before, during and after construction to ensure reliability and integrity of their systems.</p>
              <h3>Advance planning</h3>
              <ul>
                <li>Designing the strength and thickness of steel or plastic to meet or exceed industry standards</li>
                <li>Coating pipelines with a protective covering to prevent damage</li>
                <li>Injecting corrosion inhibitors and installing cathodic protection (low voltage current that runs across pipeline) to safeguard steel from corrosion</li>
                <li>Warn others to stay away</li>
                <li>Evaluating risks posed to underground assets under different operating conditions</li>
              </ul>
              <h3>During construction</h3>
              <ul>
                <li>Burying pipe at appropriate depths depending on type and location of the line</li>
                <li>Examining (through X-rays) the welds of pipe connections to look for signs of defects or cracks</li>
                <li>Testing to confirm integrity before assets become operational</li>
                <li>Placing pipeline markers at regular intervals aboveground to visually indicate their underground presence</li>
              </ul>
              <h3>Maintenance and ongoing efforts</h3>
              <ul className="last">
                <li>Maintaining a clear right of way for regular inspections (by air or on foot) to check for signs of a leak, obstruction or encroachment</li>
                <li>Marking where pipelines cross roads, waterways and railroad tracks</li>
                <li>Monitoring the pressure and flow of product being transported</li>
                <li>Training emergency responders on how to recognize problems (for example, a potential product release) and respond properly</li>
                <li>Offering pipeline awareness and key safety information to impacted audiences</li>
                <li>Adding an odorant with a distinctive smell (typically like rotten eggs or a burnt match) to consumer-ready gas distribution systems to help recognize leaks</li>
                <li>Providing training opportunities so employees meet specific qualification standards</li>
                <li>Preparing and practicing emergency response procedures (training drills)</li>
                <li>Participating in the state one call notification programs (811) and promoting “Call Before You Dig” messaging so underground facilities are marked before digging</li>
              </ul>
            </div>
          </div>
          <div className="row">
          </div>
        </div>
      </div>
        ); } } PreventionMeasuresPage.propTypes = {};

      export default PreventionMeasuresPage;



// WEBPACK FOOTER //
// ./src/components/pages/preventionMeasures/PreventionMeasuresPage.js